var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"display-1 font-weight-light"},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }